import React from "react";
import { StoreListForPickup } from "components/store/StoreList";
import { NotPersistAction } from "store/actions";
import { useLang } from "hooks";
import { useSelector } from "react-redux";
import SlideInLayout from "components/layouts/SlideInLayout";

function PickupStoresModal() {
  const { pickupStoreModal } = useSelector((state) => state.NotPersist);
  const { currentLang } = useLang();
  const { stores } = useSelector((state) => state?.brand);

  return (
    <>
      <SlideInLayout
        shouldCloseOnEsc="No"
        shouldCloseOnOverlayClick="No"
        open={pickupStoreModal}
        handleClose={NotPersistAction.togglePickupStoreModal(false)}
        container={{
          className: `py-2`,
        }}
      >
        <StoreListForPickup
          stores={stores}
          header={false}
          headerLabel=""
          styleClasses={`h-full`}
        />
      </SlideInLayout>
    </>
  );
}

export default PickupStoresModal;
